export namespace BrokerageNameDeocder {
    export function decode(name: string) {
        if (name.toLowerCase().indexOf('eastide') !== -1) {
            return 'et';
        }
        if (name.toLowerCase().indexOf('master') !== -1 && name.toLowerCase().indexOf('trust') !== -1) {
            return 'mt';
        }
        if (name.toLowerCase().indexOf('master') !== -1 && name.toLowerCase().indexOf('choice') !== -1) {
            return 'mc';
        }
        if (name.toLowerCase().indexOf('rifo') !== -1 && name.toLowerCase().indexOf('realty') !== -1) {
            return 'rifo';
        }
        if (name.toLowerCase().indexOf('royal') !== -1 && name.toLowerCase().indexOf('elite') !== -1) {
            return 'royal';
        }
        if (name.toLowerCase().indexOf('homeart') !== -1 && name.toLowerCase().indexOf('realty') !== -1) {
            return 'homeart';
        }
        if (name.toLowerCase().indexOf('rifo') !== -1 && name.toLowerCase().indexOf('group') !== -1) {
            return 'group';
        }
        return 'N/A';
    }

    export function isEstate(name: string) {
        return BrokerageNameDeocder.decode(name) === 'et' ? true : false;
    }

    export function isMasterTrust(name: string) {
        return BrokerageNameDeocder.decode(name) === 'mt' ? true : false;
    }

    export function isMasterChoice(name: string) {
        return BrokerageNameDeocder.decode(name) === 'mc' ? true : false;
    }

    export function isRifo(name: string) {
        return BrokerageNameDeocder.decode(name) === 'rifo' ? true : false;
    }

    export function isRoyalElite(name: string) {
        return BrokerageNameDeocder.decode(name) === 'royal' ? true : false;
    }

    export function isHomeArt(name: string) {
        return BrokerageNameDeocder.decode(name) === 'homeart' ? true : false;
    }

    export function isRifoGroup(name: string) {
        return BrokerageNameDeocder.decode(name) === 'group' ? true : false;
    }

}
